__webpack_require__.p = "https://assets.atlas.so/kb/_next/";